import { VpStarRating } from '@vtmn-play/react';
import styles from './styles.module.scss';

export type BenefitType = {
  id: number;
  notation: string;
  label: string;
};

export const Benefit = ({ benefit }: { benefit: BenefitType }) => {
  const { notation, label } = benefit;
  const isStringNotation = isNaN(Number(notation));

  return (
    <div data-testid="benefit" className={styles['spo-benefit']}>
      <div>{label}</div>
      <div className={styles['spo-benefit-notation']}>
        {isStringNotation ? (
          <div className={styles['spo-benefit-string-notation']}>
            {notation}
          </div>
        ) : (
          <VpStarRating
            score={Number(notation)}
            aria-label={`The score is ${notation} out of 5 stars`}
          />
        )}
      </div>
    </div>
  );
};
